import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ScenarioCard = ({ title, description, icon, image, imageAlt, isActive, onClick, badge }) => {
  return (
    <button
      onClick={onClick}
      className={`relative w-full text-left p-4 rounded-xl border-2 transition-all duration-300 hover:scale-105 ${
        isActive 
          ? 'border-accent bg-accent/5 shadow-lg shadow-accent/20' 
          : 'border-border bg-card hover:border-accent/50'
      }`}
    >
      {badge && (
        <div className="absolute top-3 right-3 px-2 py-1 rounded-md bg-accent text-accent-foreground text-xs font-semibold">
          {badge}
        </div>
      )}
      
      <div className="flex items-start gap-3 mb-3">
        <div className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${
          isActive ? 'bg-accent text-accent-foreground' : 'bg-muted text-foreground'
        }`}>
          <Icon name={icon} size={24} />
        </div>
        
        {image && (
          <div className="w-12 h-12 rounded-lg overflow-hidden flex-shrink-0">
            <Image 
              src={image} 
              alt={imageAlt}
              className="w-full h-full object-cover"
            />
          </div>
        )}
      </div>
      
      <h3 className="font-headline font-semibold text-foreground mb-1">{title}</h3>
      <p className="text-sm text-muted-foreground line-clamp-2">{description}</p>
    </button>
  );
};

export default ScenarioCard;